import { useContextOrThrow } from '@deephaven/react-hooks';
import { ThemeContext } from "./ThemeProvider.js";
/**
 * Hook to get the current `ThemeContextValue`.
 */
export function useTheme() {
  return useContextOrThrow(ThemeContext, 'No ThemeContext value found. Component must be wrapped in a ThemeContext.Provider');
}
export default useTheme;
//# sourceMappingURL=useTheme.js.map